export default {
  setToken(_, value) {
    localStorage.setItem('session_id', value);
  },
  setLoggedUser(state, value) {
    state.loggedUser = value;
  },
  setMainBackgroundColor(state, color) {
    if (color) {
      state.mainBackgroundColor = color;
    } else {
      state.mainBackgroundColor = state.defaultMainBackgroundColor;
    }
  },
};
